export default "__VITE_ASSET__BhhSYxJL__"